import { motion } from 'framer-motion'
import { MapPin, Calendar, Globe } from 'lucide-react'
import { useLanguage } from '../contexts/LanguageContext'

const About = () => {
  const { t } = useLanguage()
  return (
    <section id="about" className="py-12 lg:py-16 bg-black">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <div className="inline-flex items-center gap-2 bg-gray-900 px-4 py-2 rounded-full mb-6">
              <span className="text-2xl">🌲</span>
              <span className="text-sm font-semibold text-gray-300">
                Made in Black Forest
              </span>
            </div>

            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 text-white">{t('about.title')}</h2>

            <p className="text-base md:text-lg lg:text-xl text-gray-400 mb-6 leading-relaxed">
              {t('about.mission')}
            </p>

            <p className="text-base md:text-lg lg:text-xl text-gray-400 mb-8 leading-relaxed">
              Unser Team kombiniert cutting-edge KI-Technologie mit benutzerfreundlichem Design,
              um das beste persönliche Finanzmanagement-Erlebnis in Deutschland zu schaffen.
            </p>

            <div className="flex flex-wrap gap-2 sm:gap-3">
              <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: 0.1 }}
                className="group"
              >
                <div className="inline-flex items-center gap-1.5 sm:gap-2 px-3 sm:px-4 py-1.5 sm:py-2 bg-gradient-to-r from-blue-500/10 to-purple-500/10 backdrop-blur-xl rounded-full border border-blue-500/30 hover:border-blue-400/60 transition-all duration-300 hover:shadow-lg hover:shadow-blue-500/20">
                  <Calendar className="text-blue-400" size={16} />
                  <span className="text-base sm:text-lg font-bold bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">2026</span>
                  <span className="text-xs sm:text-sm text-gray-400">Gegründet</span>
                </div>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: 0.2 }}
                className="group"
              >
                <div className="inline-flex items-center gap-1.5 sm:gap-2 px-3 sm:px-4 py-1.5 sm:py-2 bg-gradient-to-r from-green-500/10 to-emerald-500/10 backdrop-blur-xl rounded-full border border-green-500/30 hover:border-green-400/60 transition-all duration-300 hover:shadow-lg hover:shadow-green-500/20">
                  <MapPin className="text-green-400" size={16} />
                  <span className="text-base sm:text-lg font-bold bg-gradient-to-r from-green-400 to-emerald-400 bg-clip-text text-transparent">Freiburg</span>
                  <span className="text-xs sm:text-sm text-gray-400">Standort</span>
                </div>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: 0.3 }}
                className="group"
              >
                <div className="inline-flex items-center gap-1.5 sm:gap-2 px-3 sm:px-4 py-1.5 sm:py-2 bg-gradient-to-r from-purple-500/10 to-pink-500/10 backdrop-blur-xl rounded-full border border-purple-500/30 hover:border-purple-400/60 transition-all duration-300 hover:shadow-lg hover:shadow-purple-500/20">
                  <Globe className="text-purple-400" size={16} />
                  <span className="text-base sm:text-lg font-bold bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">Germany</span>
                  <span className="text-xs sm:text-sm text-gray-400">Fokus</span>
                </div>
              </motion.div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative"
          >
            <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-3xl p-16 flex flex-col items-center justify-center min-h-[400px] border border-gray-700">
              <motion.div
                animate={{ y: [0, -10, 0] }}
                transition={{ duration: 2, repeat: Infinity }}
                className="text-9xl mb-6"
              >
                📍
              </motion.div>
              <div className="text-2xl font-bold text-white">Freiburg im Breisgau</div>
              <div className="flex items-center gap-2 text-gray-400 mt-2">
                <MapPin size={16} />
                <span>Baden-Württemberg, Deutschland</span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  )
}

export default About
